class ModelModal extends HTMLElement {
  constructor() {
    super();

    this.closeButtons = this.querySelectorAll(`.model-modal__close`);

    this.openButtons = document.querySelectorAll(
      `.model-modal__open[data-modal-id="${this.id}"]`
    );

    this.arButtons = document.querySelectorAll(
      `.product__media-item .model-modal__ar[data-modal-id="${this.id}"]`
    );

    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.handleClose.bind(this))
    );

    this.openButtons.forEach((button) =>
      button.addEventListener("click", this.handleOpen.bind(this))
    );

    this.arButtons.forEach((button) =>
      button.addEventListener("click", this.handleActivateAR.bind(this))
    );
  }

  handleClose() {
    document.body.style.overflow = "auto";
    this.classList.add("hidden");
  }

  handleOpen() {
    document.body.style.overflow = "hidden";
    this.classList.remove("hidden");

    if (this.modelViewer && this.modelViewer.loaded) {
      modelViewer.fieldOfView = 1;
      modelViewer.cameraOrbit = "1 1 1";
    }
  }

  handleActivateAR() {
    const modelViewer = this.querySelector("model-viewer");

    if (!modelViewer) return;

    this.arButtons.forEach((button) => button.classList.add("loading"));

    modelViewer
      .activateAR()
      .finally(() =>
        this.arButtons.forEach((button) => button.classList.remove("loading"))
      );
  }
}

if (!customElements.get("model-modal"))
  customElements.define("model-modal", ModelModal);
